import { Input, Pagination, Tabs, Tag } from 'antd';
import { useEffect, useMemo, useRef, useState } from 'react';
import Boton from '../Components/Atoms/Boton';
import Esqueleto from '../Components/Atoms/Esqueleto';
import {
  SearchOutlined,
  SyncOutlined,
  UserAddOutlined,
  InteractionOutlined,
  StopOutlined,
  EditOutlined,
  SolutionOutlined
} from '@ant-design/icons';
import clienteAxios from '../Utils/clienteAxios';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import NewUser from '../Components/Organisms/NewUser';
import TablaManagers from '../Components/Organisms/TablaManagers';
import CuentasVinculadas from '../Components/Organisms/CuentasVinculadas';
import ModalManagerDepar from '../Components/Organisms/ModalManagerDepar';

const iniciales = (nombre) =>
  (nombre || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte[0])
    .join('')
    .toUpperCase();

const sinDefinir = (valor) =>
  valor === null || valor === undefined || valor === '' || valor === 'SIN DEFINIR';

// Una etiqueta por dato; lo que falta se marca en rojo para que se vea qué completar.
const Etiqueta = ({ valor }) =>
  sinDefinir(valor) ? <Tag color="red">Sin definir</Tag> : <Tag color="geekblue">{valor}</Tag>;

const Campo = ({ etiqueta, children }) => (
  <div className="usuarios-campo">
    <div className="usuarios-etiqueta">{etiqueta}</div>
    <div className="usuarios-valor">{children}</div>
  </div>
);

Etiqueta.propTypes = { valor: PropTypes.string };
Campo.propTypes = { etiqueta: PropTypes.string, children: PropTypes.node };

const Users = () => {
  const [data, setData] = useState();
  const [modalUser, setModalUser] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingManagers, setLoadingManagers] = useState(true);
  const [userAction, setUserAction] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [seleccionadoId, setSeleccionadoId] = useState(null);
  const [pagina, setPagina] = useState(1);
  const fichaRef = useRef(null);
  const [dataUser, setDataUser] = useState({});
  const [scrollY, setScrollY] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataManager, setDataManager] = useState();
  const [nameManager, setNameManager] = useState(null);
  const [nameDepartment, setNameDepartment] = useState(null);

  let OptionDepartment = [
    { value: 'Administración', label: 'Administración', key: 1 },
    { value: 'Almacén', label: 'Almacén', key: 2 },
    { value: 'Calidad', label: 'Calidad', key: 3 },
    { value: 'Compras', label: 'Compras', key: 4 },
    { value: 'Dirección', label: 'Dirección', key: 5 },
    { value: 'Diseño Operativo', label: 'Diseño Operativo', key: 6 },
    { value: 'Importaciones', label: 'Importaciones', key: 7 },
    { value: 'Logística', label: 'Logística', key: 8 },
    { value: 'Mesa De Control', label: 'Mesa De Control', key: 9 },
    { value: 'Producción', label: 'Producción', key: 10 },
    { value: 'Recursos Humanos', label: 'Recursos Humanos', key: 11 },
    { value: 'Tecnología E Innovación', label: 'Tecnología E Innovación', key: 12 },
    { value: 'Ventas', label: 'Ventas', key: 13 },
    { value: 'Sin Definir', label: 'Sin Definir', key: 14 },
    { value: 'Marketing Promo Life', label: 'Marketing Promo Life', key: 15 }
  ];

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Usuarios y managers se piden por separado: cada uno se muestra en cuanto llega.
  useEffect(() => {
    setLoading(true);
    setLoadingManagers(true);
    clienteAxios
      .get(`/users`)
      .then((respuesta) => setData(respuesta.data[0]))
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
    clienteAxios
      .get(`/managers/department`)
      .then((respuesta) => setDataManager(respuesta.data.Managers.reverse()))
      .catch((error) => console.error(error))
      .finally(() => setLoadingManagers(false));
  }, [userAction]);

  const namesUsers = data?.map((item) => {
    return {
      value: item?.id,
      label: item?.name,
      key: item?.id
    };
  });

  function deleteUser(id) {
    console.log('id', id);
    Swal.fire({
      title: '¿Deseas eliminar este usuario?',
      icon: 'warning',
      reverseButtons: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#1677ff',
      cancelButtonColor: '#ff4d4f'
    })
      .then((result) => {
        if (result.isConfirmed) {
          clienteAxios.delete(`/users/${id}`).then(() => {
            Swal.fire({
              title: 'Usuario eliminado correctamente',
              text: 'El usuario se ha eliminado correctamente',
              icon: 'success',
              confirmButtonText: 'Aceptar'
            }).then(() => {
              setUserAction(!userAction);
            });
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: 'Error',
          text: 'Ups ha ocurrido un error al eliminar el usuario',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        });
      });
  }

  function renviarPassword(id) {
    Swal.fire({
      title: '¿Deseas enviar su acceso a este usuario?',
      icon: 'warning',
      reverseButtons: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#1677ff',
      cancelButtonColor: '#ff4d4f'
    }).then((result) => {
      if (result.isConfirmed) {
        clienteAxios.get(`/users/sendNewAccess/${id}`).then(() => {
          Swal.fire({
            title: 'Se ha enviado el acceso al correo',
            icon: 'success',
            confirmButtonText: 'Aceptar'
          }).then(() => {
            setUserAction(!userAction);
          });
        });
      }
    });
  }

  function sincronizarUser() {
    Swal.fire({
      title: '¿Deseas sincronizar la lista de usuarios?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.isConfirmed) {
        clienteAxios.get(`/syncUsers`).then((respuesta) => {
          Swal.fire({
            title: respuesta?.data?.msg,
            text: 'Se han sincronizado los usuarios exitosamente',
            icon: 'success',
            confirmButtonText: 'Aceptar'
          }).then(() => {
            setUserAction(!userAction);
          });
        });
      }
    });
  }

  const usuarios = useMemo(
    () =>
      (data || []).map((item) => ({
        id: item?.id,
        name: item?.name,
        email: item?.email,
        role: item?.what_roles?.[0]?.display_name,
        role_id: item?.what_roles?.[0]?.id,
        department: item?.department,
        department_id: item?.department_id,
        company: item?.company,
        company_id: item?.company_id,
        area: item?.area,
        area_id: item?.area_id
      })),
    [data]
  );

  const visibles = useMemo(() => {
    const texto = busqueda.trim().toLowerCase();
    if (!texto) return usuarios;
    return usuarios.filter((u) =>
      [u.name, u.email, u.company, u.department, u.area, u.role].some((campo) =>
        (campo || '').toString().toLowerCase().includes(texto)
      )
    );
  }, [usuarios, busqueda]);

  const porPagina = 25;
  const paginaVisible = visibles.slice((pagina - 1) * porPagina, pagina * porPagina);
  const actual = visibles.find((u) => u.id === seleccionadoId) || paginaVisible[0];

  const seleccionar = (id) => {
    setSeleccionadoId(id);
    // En pantallas angostas la ficha queda debajo de la lista.
    if (window.innerWidth <= 991) fichaRef.current?.scrollIntoView({ block: 'start' });
  };

  const editar = (u) => {
    setDataUser({
      id: u.id,
      name: u.name,
      email: u.email,
      role_id: u.role_id,
      department_id: u.department_id,
      company_id: u.company_id,
      area_id: u.area_id
    });
    setModalUser(true);
    setScrollY(window.scrollY);
    document.body.classList.add('body-fixed');
  };

  const handleAdd = async () => {
    setLoadingManagers(true);
    try {
      await clienteAxios.post(`/create/manager/department`, {
        id_user: nameManager,
        id_department: nameDepartment
      });
      handleCancel();
      Swal.fire({
        icon: 'success',
        title: 'Concepto agregado correctamente!',
        showCancelButton: false,
        confirmButtonText: 'LISTO'
      });
      setUserAction(!userAction);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error al asignar el manager al departamento!',
        showCancelButton: false,
        confirmButtonText: 'INTENTAR DE NUEVO'
      });
    } finally {
      setLoadingManagers(false); // Asegura que el estado de carga se restablezca
    }
  };

  return (
    <>
      <div className="title-content-between usuarios-encabezado">
        <h1 className="mb-2 mr-5">Usuarios</h1>
        <Boton type="secondary" icon={<SyncOutlined />} onClick={() => sincronizarUser()}>
          Sincronizar
        </Boton>
        <Boton type="secondary" icon={<SolutionOutlined />} onClick={showModal}>
          Manager / Departamento
        </Boton>
        <Boton
          type="primary"
          icon={<UserAddOutlined />}
          onClick={() => {
            setDataUser({});
            setModalUser(true);
            setScrollY(window.scrollY);
            document.body.classList.add('body-fixed');
          }}>
          Agregar usuario
        </Boton>
      </div>

      <Tabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: `Usuarios`,
            children: (
              <>
                <div className="usuarios-directorio">
                  <section className="usuarios-lista" aria-label="Lista de usuarios">
                    <Input
                      allowClear
                      prefix={<SearchOutlined aria-hidden="true" />}
                      placeholder="Buscar por nombre, correo, empresa o rol"
                      aria-label="Buscar usuarios"
                      value={busqueda}
                      onChange={(e) => {
                        setBusqueda(e.target.value);
                        setPagina(1);
                      }}
                    />
                    <div className="usuarios-conteo">
                      {loading ? (
                        <Esqueleto ancho={70} alto={13} />
                      ) : (
                        <>
                          {visibles.length} {visibles.length === 1 ? 'usuario' : 'usuarios'}
                        </>
                      )}
                    </div>
                    <ul className="usuarios-items" aria-busy={!!loading}>
                      {loading ? (
                        <>
                          <li className="sr-only" role="status">
                            Cargando usuarios
                          </li>
                          {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
                            <li
                              key={i}
                              className="usuarios-item usuarios-item--esqueleto"
                              aria-hidden="true">
                              <Esqueleto ancho={36} alto={36} radio="50%" />
                              <span className="usuarios-item__texto" style={{ gap: 6, flex: 1 }}>
                                <Esqueleto ancho="60%" alto={14} />
                                <Esqueleto ancho="80%" alto={12} />
                              </span>
                            </li>
                          ))}
                        </>
                      ) : null}
                      {(loading ? [] : paginaVisible).map((u) => (
                        <li key={u.id}>
                          <button
                            type="button"
                            aria-pressed={actual?.id === u.id}
                            className={
                              actual?.id === u.id ? 'usuarios-item is-activo' : 'usuarios-item'
                            }
                            onClick={() => seleccionar(u.id)}>
                            <span className="usuarios-avatar" aria-hidden="true">
                              {iniciales(u.name)}
                            </span>
                            <span className="usuarios-item__texto">
                              <span className="usuarios-item__nombre">{u.name}</span>
                              <span className="usuarios-item__detalle">
                                {[u.company, u.department]
                                  .filter((v) => !sinDefinir(v))
                                  .join(' · ') || 'Sin definir'}
                              </span>
                            </span>
                          </button>
                        </li>
                      ))}
                    </ul>
                    {visibles.length === 0 && !loading ? (
                      <div className="usuarios-vacio">
                        No hay usuarios que coincidan con la búsqueda.
                      </div>
                    ) : null}
                    {loading ? null : (
                      <Pagination
                        className="usuarios-paginacion"
                        size="small"
                        current={pagina}
                        pageSize={porPagina}
                        total={visibles.length}
                        showSizeChanger={false}
                        hideOnSinglePage
                        onChange={setPagina}
                      />
                    )}
                  </section>

                  <section className="usuarios-ficha" ref={fichaRef} aria-label="Datos del usuario">
                    {loading ? (
                      <div aria-hidden="true">
                        <div className="usuarios-ficha__cabecera">
                          <Esqueleto ancho={48} alto={48} radio="50%" />
                          <div style={{ flex: 1 }}>
                            <div className="esqueleto-linea" style={{ height: 31 }}>
                              <Esqueleto ancho="45%" alto={20} />
                            </div>
                            <div className="esqueleto-linea" style={{ height: 24 }}>
                              <Esqueleto ancho="35%" alto={14} />
                            </div>
                          </div>
                        </div>
                        <div className="usuarios-campos">
                          {[0, 1, 2, 3].map((i) => (
                            <div key={i}>
                              <div
                                className="esqueleto-linea usuarios-etiqueta"
                                style={{ height: 20 }}>
                                <Esqueleto ancho={80} alto={12} />
                              </div>
                              <div className="esqueleto-linea" style={{ height: 22 }}>
                                <Esqueleto ancho={110} alto={22} />
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="usuarios-acciones">
                          <Esqueleto ancho={100} alto={40} radio={24} />
                          <Esqueleto ancho={160} alto={40} radio={24} />
                          <Esqueleto ancho={160} alto={40} radio={24} />
                        </div>
                      </div>
                    ) : actual ? (
                      <>
                        <div className="usuarios-ficha__cabecera">
                          <span
                            className="usuarios-avatar usuarios-avatar--grande"
                            aria-hidden="true">
                            {iniciales(actual.name)}
                          </span>
                          <div>
                            <h2 className="usuarios-ficha__nombre">{actual.name}</h2>
                            <div className="usuarios-ficha__correo">{actual.email}</div>
                          </div>
                        </div>
                        <div className="usuarios-campos">
                          <Campo etiqueta="Empresa">
                            <Etiqueta valor={actual.company} />
                          </Campo>
                          <Campo etiqueta="Rol">
                            <Etiqueta valor={actual.role} />
                          </Campo>
                          <Campo etiqueta="Departamento">
                            <Etiqueta valor={actual.department} />
                          </Campo>
                          <Campo etiqueta="Área">
                            <Etiqueta valor={actual.area} />
                          </Campo>
                        </div>
                        <div className="usuarios-acciones">
                          <Boton
                            type="primary"
                            icon={<EditOutlined />}
                            onClick={() => editar(actual)}>
                            Editar
                          </Boton>
                          <Boton
                            type="secondary"
                            icon={<InteractionOutlined />}
                            onClick={() => renviarPassword(actual.id)}>
                            Reenviar acceso
                          </Boton>
                          <Boton
                            danger
                            icon={<StopOutlined />}
                            onClick={() => deleteUser(actual.id)}>
                            Eliminar usuario
                          </Boton>
                        </div>
                      </>
                    ) : (
                      <div className="usuarios-vacio">Elige un usuario de la lista.</div>
                    )}
                  </section>
                </div>
              </>
            )
          },
          {
            key: '2',
            label: `Manager de Departamento`,
            children: <TablaManagers dataManager={dataManager} loading={loadingManagers} />
          },
          {
            key: '3',
            label: `Cuentas vinculadas`,
            children: <CuentasVinculadas />
          }
        ]}
      />

      {modalUser && (
        <NewUser
          modalUser={modalUser}
          setModalUser={setModalUser}
          userAction={userAction}
          setUserAction={setUserAction}
          dataUser={dataUser}
          setDataUser={setDataUser}
          setScrollY={setScrollY}
          scrollY={scrollY}
        />
      )}

      <ModalManagerDepar
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        handleAdd={handleAdd}
        namesUsers={namesUsers}
        setNameManager={setNameManager}
        nameDepartment={nameDepartment}
        setNameDepartment={setNameDepartment}
        OptionDepartment={OptionDepartment}
      />
    </>
  );
};

export default Users;
